class VTOwidget extends HTMLElement {
  constructor() {
    super();
    // Bind methods to preserve 'this' context
    this.hide = this.hide.bind(this);
    this.show = this.show.bind(this);
    this.openVto = this.openVto.bind(this);
    this.stopVto = this.stopVto.bind(this);
    this.createWidget = this.createWidget.bind(this);

    this.params = {
      apiKey: "6zQDde5kfRSG1gc2efp3LJN-U4MwCAyLyM9Ch-o6KnDVPbgB7CNgLA",
      onStopVto: this.hide,
      onIssue: (data) => {
        console.log(data);
      },
    };
    this.fitmix = this.querySelector("#fitmix-container");
    this.fitmixInstance = this.createWidget();
    window.fitmixWidget = this;

    // Set up close button
    const closeButton = this.querySelector(".vto-close-button");
    if (closeButton) {
      closeButton.addEventListener("click", this.stopVto);
    }

    // Close when clicking on the overlay background
    this.addEventListener("click", (e) => {
      if (e.target === this) {
        this.stopVto();
      }
    });
  }
  createWidget() {
    return FitMix.createWidget("fitmix-container", this.params, () => {
      console.log("VTO widget created");
      document
        .querySelector(".solstice__product-new")
        .classList.add("VTO-ready-to-use");
      if (window.initialSelectedVariantBarcode) {
        this.fitmixInstance.setFrame(window.initialSelectedVariantBarcode);
        window.initialVTObutton.classList.add("VTO-available");
      }
    });
  }
  hide() {
    this.classList.remove("active");
    document.body.classList.remove("block-body-scroll");
  }
  show() {
    this.classList.add("active");
    document.body.classList.add("block-body-scroll");
  }
  openVto() {
    this.fitmixInstance.startVto("live");
    this.show();
  }
  stopVto() {
    this.fitmixInstance.stopVto();
    this.hide();
  }
}
customElements.define("vto-widget", VTOwidget);
class VariantPicker extends HTMLElement {
  constructor() {
    super();
    this.sectionId = this.dataset.sectionid;
    this.buyButtonInput = this.querySelector("input[name=id]");

    this.sizeGuide = this.querySelector("#sizeGuide");
    this.sizeGuide_modal = document.querySelector("#sizeGuide_modal");
    this.sizeGuide_overlay = this.sizeGuide_modal.parentElement;
    this.sizeGuide_close = document.querySelector("#sizeGuide_close");

    this.sizeRadios = this.querySelectorAll(".size-radio");
    this.colorRadios = this.querySelectorAll(".color-radio-new");
    this.variants = window.productObj.variants;

    this.productHandle = this.dataset.productHandle;
    this.selectedFrameColorSpan = this.querySelector(
      ".color-label-new span.selected_frame_color"
    );
    this.selectedLensColorSpan = this.querySelector(
      ".color-label-new span.selected_lens_color"
    );

    this.slideButton = this.querySelector(
      ".color-options-new .glide__arrows .glide__arrow"
    );
    const selectedColorCombo = Array.from(this.colorRadios).find(
      (r) => r.checked
    )?.value;
    if (!selectedColorCombo) {
      if (Array.from(this.colorRadios).length > 0) {
        Array.from(this.colorRadios)[0].checked = true;
      }
    }

    this.verifyVTOAvailabilityForSelectedVariant(true);
  }
  async verifyVTOAvailabilityForSelectedVariant(initialLoad = false) {
    let vtoButton = document.querySelector(
      ".solstice__product-try-on-button button"
    );

    try {
      if (!this.vtoAvailabilityData) {
        const data = await this.getAvailability(
          this.variants.map((variant) => variant.barcode)
        );
        this.vtoAvailabilityData = data;
      }
      const selectedVariantBarcode = `${this.getSelectedVariant().barcode}`;
      let foundFrame = false;
      this.vtoAvailabilityData.forEach((item) => {
        if (item.uid === selectedVariantBarcode && item.available) {
          foundFrame = true;
          if (initialLoad) {
            window.initialSelectedVariantBarcode = selectedVariantBarcode;
            window.initialVTObutton = vtoButton;
            return;
          }
          vtoButton.classList.add("VTO-available");
          window.fitmixWidget.fitmixInstance.setFrame(selectedVariantBarcode);
        }
      });
      if (!foundFrame) {
        vtoButton.classList.remove("VTO-available");
      }
    } catch (error) {
      console.log("error");
      console.log(error);
      vtoButton.classList.remove("VTO-available");
    }
  }
  async getAvailability(idTable) {
    // Put your apiKey as an environment Variable
    const apiKey = "6zQDde5kfRSG1gc2efp3LJN-U4MwCAyLyM9Ch-o6KnDVPbgB7CNgLA";
    const url = `https://product-api.fittingbox.com/glasses-metadata/availability?apiKey=${apiKey}&uidList=${idTable.join(
      ","
    )}`;

    const result = await fetch(url);
    if (result.ok) {
      return result.json();
    }
    throw new Error("an error occured");
  }
  connectedCallback() {
    this.addEvents();
    this.initGlide();
    const initiallyChecked = Array.from(this.sizeRadios).find(
      (radio) => radio.checked
    );
    if (initiallyChecked) {
      // initiallyChecked.dispatchEvent(new Event("change", { bubbles: true }));
    }
  }

  openSizeGuide() {
    this.sizeGuide_overlay.classList.add("open");
    document.body.classList.add("block-body-scroll");
  }
  closeSizeGuide() {
    this.sizeGuide_overlay.classList.remove("open");
    document.body.classList.remove("block-body-scroll");
  }

  addEvents() {
    this.sizeRadios.forEach((radio) => {
      radio.addEventListener("change", () => {
        const selectedSize = radio.value;

        const validCombos = new Set();
        this.variants.forEach((variant) => {
          if (variant.option1 === selectedSize) {
            const comboKey = `${variant.option2.trim()}~${
              variant.option3 ? variant.option3.trim() : ""
            }`;
            validCombos.add(comboKey);
          }
        });

        let firstAvailableRadio = null;

        this.colorRadios.forEach((colorRadio) => {
          const comboKey = colorRadio.value;
          const label = colorRadio.nextElementSibling;
          if (validCombos.has(comboKey)) {
            colorRadio.disabled = false;
            label.classList.remove("disabled-new");

            if (!firstAvailableRadio) {
              firstAvailableRadio = colorRadio;
            }
          } else {
            colorRadio.disabled = true;
            colorRadio.checked = false;
            label.classList.add("disabled-new");
          }
        });

        if (firstAvailableRadio) {
          firstAvailableRadio.checked = true;
          firstAvailableRadio.dispatchEvent(
            new Event("change", { bubbles: true })
          );
        }
      });
    });

    this.colorRadios.forEach((radio) => {
      radio.addEventListener("change", () => {
        this.addToCart.disabled = true;
        this.addToCart
          .querySelector(".loading-spinner")
          .classList.remove("hidden");
        const [frame, lens] = radio.value.split("~");
        this.selectedFrameColorSpan.textContent = frame;
        if (this.selectedLensColorSpan)
          this.selectedLensColorSpan.textContent = lens;

        const variant = this.getSelectedVariant();
        const rxConfiguratorLoader = document.querySelector(
          "rx-configurator-loader"
        );
        if (rxConfiguratorLoader)
          rxConfiguratorLoader.classList.add("disabled");
        if (!variant) {
          this.addToCart
            .querySelector(".loading-spinner")
            .classList.add("hidden");
          this.addToCart.querySelector(".button-text").innerText =
            theme.strings.unavailable;

          return;
        }
        this.requestSection(variant.id).then(() => {
          this.buyButtonInput.value = variant.id;
          this.addToCart
            .querySelector(".loading-spinner")
            .classList.add("hidden");
        });
      });
    });
    this.sizeGuide.addEventListener("click", (event) => {
      this.openSizeGuide();
    });
    this.sizeGuide_overlay.addEventListener("click", (event) => {
      if (event.currentTarget === event.target) {
        this.closeSizeGuide();
      }
    });
    this.sizeGuide_close.addEventListener("click", (event) => {
      this.closeSizeGuide();
    });
  }

  getSelectedVariant() {
    if (this.variants.length == 1) return this.variants[0];
    const selectedSize = Array.from(this.sizeRadios).find(
      (r) => r.checked
    )?.value;
    const selectedColorCombo = Array.from(this.colorRadios).find(
      (r) => r.checked
    )?.value;

    if (!selectedSize || !selectedColorCombo) return null;

    const [frameColor, lensColor] = selectedColorCombo.split("~");
    if (lensColor && lensColor.length > 0)
      return this.variants.find(
        (variant) =>
          variant.option1 === selectedSize &&
          variant.option2.trim() === frameColor &&
          variant.option3?.trim() === lensColor
      );
    else {
      return this.variants.find(
        (variant) =>
          variant.option1 === selectedSize &&
          variant.option2.trim() === frameColor
      );
    }
  }

  initGlide() {
    const glide = new Glide("variant-picker .glide", {
      type: "slider",
      startAt: 0,
      perView: 4,
      gap: 5,
      focusAt: "0",
      bound: true,
      breakpoints: {
        475: { perView: 3 },
      },
    });
    glide.on("resize", function (e) {
      if (glide.settings.perView < 4 && glide._c.Html.slides.length > 3) {
        document.querySelector(
          ".color-options-new .glide__arrows"
        ).style.display = "flex";
      }
    });
    glide.on("mount.after", function (e) {
      if (glide.settings.perView < 4 && glide._c.Html.slides.length > 3) {
        document.querySelector(
          ".color-options-new .glide__arrows"
        ).style.display = "flex";
      }
    });
    glide.mount();
    this.variantGlideSlide = glide;
    this.slideButton.style.display = "block";
    // let goToSlide = true;
    // if (window.innerWidth > 1100 && this.colorRadios.length <= 4) {
    //   this.slideButton.style.display = "none";
    //   goToSlide = false;
    // }
    // if (window.innerWidth <= 1100 && this.colorRadios.length <= 3) {
    //   this.slideButton.style.display = "none";
    //   goToSlide = false;
    // }
    // if (window.innerWidth <= 992 && this.colorRadios.length <= 6) {
    //   this.slideButton.style.display = "none";
    //   goToSlide = false;
    // }
    // if (window.innerWidth <= 768 && this.colorRadios.length <= 5) {
    //   this.slideButton.style.display = "none";
    //   goToSlide = false;
    // }
    // if (window.innerWidth <= 600 && this.colorRadios.length <= 4) {
    //   this.slideButton.style.display = "none";
    //   goToSlide = false;
    // }
    // if (goToSlide) this.goToActiveVariantSlide();
  }
  goToActiveVariantSlide() {
    this.colorRadios.forEach((radio) => {
      if (radio.checked) {
        this.variantGlideSlide.go(`=${radio.dataset.index}`);
      }
    });
  }

  async requestSection(variantId) {
    const handle = this.productHandle; // e.g., from meta or dataset
    const url = `/products/${handle}?sections=${this.sectionId},rx-configurator&variant=${variantId}`;
    return fetch(url)
      .then((response) => response.json())
      .then((html) => {
        window.history.pushState(
          {},
          "",
          `/products/${handle}?variant=${variantId}`
        );

        const parser = new DOMParser();
        const newDom = parser.parseFromString(
          html[this.sectionId],
          "text/html"
        );

        const newDomRx = parser.parseFromString(
          html["rx-configurator"],
          "text/html"
        );

        const itemsToAddToDom = [
          ".frame-measurements-items",
          "#main_product_new_image_viewer",
          ".product-new-bottom-content",
          ".product-new-image-misc-mobile",
          ".product-new-main-title",
          "buy-buttons",
          ".product-new-bottom-mobile .product-new-bottom",
          ".product-new-main-price",
          "rx-configurator-loader",
          "#sizeGuide_modal",
          ".solstice__product-size-guide-top > span",
          ".solstice__product-details-content",
          "product-details",
          ".solstice__product-shipping-label",
          ".solstice__product-new-main-title-desktop",
          ".solstice__product-new-main-title-mobile",
          ".solstice__product-new-main-price",
          ".solstice__product-new-main-price-desktop",
        ];

        itemsToAddToDom.forEach((item) => {
          const destination = document.querySelector(item);
          const source = newDom.querySelector(item);
          if (destination && source) {
            destination.outerHTML = source.outerHTML;
          }
        });

        const destRx = document.querySelector("rx-configurator");
        const sourceRx = newDomRx.querySelector("rx-configurator");
        this.verifyVTOAvailabilityForSelectedVariant();

        if (destRx && sourceRx) {
          destRx.outerHTML = sourceRx.outerHTML;
          document.querySelector("[name='properties[_link_id]']").value =
            destRx.generateRandomId();
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }
}

customElements.define("variant-picker", VariantPicker);

class BuyButtons extends HTMLElement {
  constructor() {
    super();
    // document.querySelector("#payment-terms-form").innerHTML = "";
    // document
    //   .querySelector("#payment-terms-form")
    //   .appendChild(this.querySelector("shopify-payment-terms"));
    this.addToCart = this.querySelector(".product-form__submit");
    document.querySelector("variant-picker").addToCart = this.addToCart;
    this.form = this.querySelector("form");
    this.form.addEventListener("submit", (e) => {
      e.preventDefault();
      // this.form.submit();
      this.addToCart.disabled = true;
      this.addToCart
        .querySelector(".loading-spinner")
        .classList.remove("hidden");

      // Get product data (prioritize global object)
      const productData = window.productObj || window.meta?.product;

      // Create FormData and add discount properties
      const formData = new FormData(this.form);

      if (productData && productData.tags) {
        const discountTag = productData.tags.find((tag) =>
          tag.startsWith("feed_import_discounted_")
        );
        const hasDiscount = !!discountTag;

        // Add discount properties to form data
        formData.append("properties[_discount_tag]", discountTag || "");
        formData.append(
          "properties[_has_discount]",
          hasDiscount ? "true" : "false"
        );
        formData.append("properties[_devmode]", "false");
        formData.append("properties[_product_name]", productData.title || "");
        // formData.append(
        //   "properties[_order_timestamp]",
        //   new Date().toISOString()
        // );
      }

      fetch(this.form.action, {
        method: "POST",
        body: formData,
      })
        .then((response) => {
          if (response.ok) {
            $("body").trigger("added.ajaxProduct");
          } else {
            console.log(response);
          }
        })
        .finally(() => {
          // this.addToCart.disabled = false;
          this.addToCart
            .querySelector(".loading-spinner")
            .classList.add("hidden");
        });
    });
  }
}

customElements.define("buy-buttons", BuyButtons);

class image_viewer extends HTMLElement {
  constructor() {
    super();
    this.initGlide = this.initGlide.bind(this);
    this.handleThumbnailClick = this.handleThumbnailClick.bind(this);
    this.updateMainImage = this.updateMainImage.bind(this);
    this.setActiveThumbnail = this.setActiveThumbnail.bind(this);
  }

  connectedCallback() {
    this.initGlide();
    this.initThumbnailHandlers();
  }

  initGlide() {
    // Check if Glide library is available
    if (typeof Glide === "undefined") {
      console.warn("Glide library not loaded");
      return;
    }

    // Initialize Glide for thumbnail slider
    const thumbnailGlideElement = this.querySelector(
      "#product-thumbnail-glide"
    );
    if (thumbnailGlideElement && !thumbnailGlideElement.glideInstance) {
      const thumbnailGlide = new Glide("#product-thumbnail-glide", {
        type: "carousel",
        startAt: 0,
        perView: 5,
        bound: true,
        focusAt: "center",
        gap: 10,
      });

      thumbnailGlideElement.glideInstance = thumbnailGlide;
      this.thumbnailGlide = thumbnailGlide;
      // Listen to Glide slide changes (when arrows are clicked or slider moves)
      thumbnailGlide.on("run.after", () => {
        this.handleGlideSlideChange(thumbnailGlide);
      });

      thumbnailGlide.mount();

      // Update main image on initial mount
      setTimeout(() => {
        this.handleGlideSlideChange(thumbnailGlide);
      }, 100);
    }
  }

  handleGlideSlideChange(glideInstance) {
    const currentIndex = glideInstance.index;
    const thumbnailSlides = this.querySelectorAll(
      ".solstice__product-new-image-viewer-thumbnail .glide__slide"
    );

    if (thumbnailSlides.length > 0 && currentIndex < thumbnailSlides.length) {
      const activeSlide = thumbnailSlides[currentIndex];
      const activeImg = activeSlide.querySelector("img");

      if (activeImg) {
        this.updateMainImage(activeImg);
        this.setActiveThumbnail(currentIndex);
      }
    }
  }

  initThumbnailHandlers() {
    const thumbnailSlides = this.querySelectorAll(
      ".solstice__product-new-image-viewer-thumbnail .glide__slide"
    );
    const mainImage = this.querySelector(
      ".solstice__product-new-image-viewer-main-image img"
    );

    if (!mainImage) return;

    thumbnailSlides.forEach((slide, index) => {
      const img = slide.querySelector("img");
      if (!img) return;

      // Handle click
      slide.addEventListener("click", (e) => {
        e.preventDefault();
        this.handleThumbnailClick(slide, img);
      });
    });
  }

  handleThumbnailClick(slide, img) {
    let index = slide.getAttribute("data-image-index");
    this.updateMainImage(img);

    this.setActiveThumbnail(slide, index);
  }

  updateMainImage(thumbnailImg) {
    const mainImage = this.querySelector(
      ".solstice__product-new-image-viewer-main-image img"
    );
    if (!mainImage || !thumbnailImg) return;

    const fullImageUrl = thumbnailImg.getAttribute("data-full-image");
    if (fullImageUrl) {
      mainImage.src = fullImageUrl;
      mainImage.alt = thumbnailImg.alt || mainImage.alt;
    }
  }

  setActiveThumbnail(index) {
    this.thumbnailGlide.go(`=${index}`);
  }
}
customElements.define("image-viewer", image_viewer);
